// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"218":"fdf5a71c941ad5a8","2651":"49494cb85949d053","2922":"5a608d37d1de51a5","4297":"481a13226a5ad12e","5608":"581cfb6578eb9a11","7752":"4f5ddea7fe8410b0","9334":"e0f9d358b7e6b9d6"}[chunkId] + ".js";
};